module.exports = __webpack_public_path__ + "static/media/trash.47fa555b.svg";